import { useNavigate } from "react-router-dom"

const AlreadyCompletedQuiz = ({ testType }) => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (testType === "assessment") {
      navigate("/assessments")
    }
    if (testType === "quiz") {
      navigate("/quiz/tests")
    }
  }

  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <p className="d-flex text-primary fs-1 justify-content-center my-5">Test is already completed by you</p>
        <div onClick={handleNavigation} className="text-muted back-hover fs-5 cursor-pointer"> <i className="bi bi-arrow-left me-1" />back to {testType} </div>
      </div>
    </>
  )
}

export default AlreadyCompletedQuiz